import type { ActionTree } from 'vuex';
import { EditorViewAction, EditorViewMutation } from './editor-view.constants';
import type { EditorViewState } from './editor-view.types';

export const actions: ActionTree<EditorViewState, EditorViewState> = {
  [EditorViewAction.SetToken]({ commit }, token: string) {
    commit(EditorViewMutation.SetToken, token);
  },

  [EditorViewAction.EmitNewToken]({ commit }, token: string) {
    commit(EditorViewMutation.SetToken, token);
    commit(EditorViewMutation.SetTokenIsSynced, false);
  },

  [EditorViewAction.SetTokenIsSynced]({ commit }, isSynced: boolean) {
    commit(EditorViewMutation.SetTokenIsSynced, isSynced);
  },

  [EditorViewAction.SetDocumentId]({ commit }, documentId: string) {
    commit(EditorViewMutation.SetDocumentId, documentId);
  },

  [EditorViewAction.SetRecipientId]({ commit }, recipientId: string) {
    commit(EditorViewMutation.SetRecipientId, recipientId);
  },

  [EditorViewAction.SetAuthId]({ commit }, authId: string) {
    commit(EditorViewMutation.SetAuthId, authId);
  },

  [EditorViewAction.SetIsPreview]({ commit }, isPreview: boolean) {
    commit(EditorViewMutation.SetIsPreview, isPreview);
  },

  [EditorViewAction.EmitSetDocumentStatusSigned]({ commit }, isSigned: boolean) {
    commit(EditorViewMutation.SetDocumentStatusSigned, isSigned);
  },

  [EditorViewAction.EmitDocumentRecalled]({ commit }, isRecalled: boolean) {
    commit(EditorViewMutation.SetDocumentRecalled, isRecalled);
  },

  [EditorViewAction.EmitPreviewTokenExpired]({ commit }, isExpired: boolean) {
    commit(EditorViewMutation.SetPreviewTokenExpired, isExpired);
  },
};
